import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrGuideFlagSeverity.ts
var t = () => e("guideFlagSeverity");
//#endregion
export { t as useTrGuideFlagSeverity };
